import { useCallback, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { DateTimeFormat } from '@xemplo/date-time';

import { isDateInputValid } from '../date-field.helper';
import { DateFieldRhfProps, DateValue } from '../date-field.types';

export function useDateFieldRhfValidation(props: DateFieldRhfProps) {
  const {
    name,
    rules,
    dateFormat = DateTimeFormat.Default,
    invalidDateMessage = 'Invalid date',
  } = props;
  const formContext = useFormContext();

  const isRequired = useMemo(() => !!rules?.required, [rules?.required]);

  const isDateValid = useCallback(
    (value?: DateValue) => {
      if (isRequired && !value) return invalidDateMessage;
      return isDateInputValid(value, isRequired, dateFormat) || invalidDateMessage;
    },
    [dateFormat, invalidDateMessage, isRequired],
  );

  const registerRules = useCallback(() => {
    const mergedRules = { ...rules, validate: { isDateValid, ...rules?.validate } };
    formContext.register(name, mergedRules);
  }, [rules, isDateValid, formContext, name]);

  useEffect(() => {
    registerRules();
  }, [registerRules]);
}
